module.exports = __webpack_public_path__ + "img/logo.64c18455.png";